<template>
<div class="chapter">
<div class="inner_page">
<p class="center titletop"><span class="textStyle0">Plutarco Elías Calles and the Mexican Revolution</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HalfTitle.vue?4bdfcb74